import {epos2Axios, eposAxios, goAxios} from "@/interceptors/axios";

class OrderService {

    async getOrder(orderid) {
        return goAxios.get('/api/orders/' + orderid);
    }
    async getOrderEpos(orderid) {
        return eposAxios.get('/index.php?page=ajax&function=getOrder&order_id='+orderid);
    }
    async getOrderHistory(orderid) {
        return goAxios.get('/api/orders/' + orderid + '/status-history');
    }
    async getOrderTimeline(orderid, options = {}) {
        const params = {
            limit: options.limit || 50,
        };
        if (options.cursor) {
            params.cursor = options.cursor;
        }
        if (options.types && options.types.length) {
            params.types = options.types.join(',');
        }
        if (options.from) {
            params.from = options.from;
        }
        if (options.to) {
            params.to = options.to;
        }
        return goAxios.get('/api/orders/' + orderid + '/timeline', { params });
    }
    async searchRFIDAccountsOrders(serverOptions) {

         try {
            let params = "search="+serverOptions.search
                +"&page="+ serverOptions.page
                +"&limit="+ serverOptions.rowsPerPage
                +"&sort_by="+ serverOptions.sortBy
                +"&sort_direction="+ serverOptions.sortType
                +"&rfid_account="+ serverOptions.rfid_account
                +"&status_filter="+ serverOptions.status_filter;
                console.log(params);
            const response = await goAxios.get('/api/orders?'+params);
            return {
                serverCurrentPageItems: response.data.data.orders || [],
                serverTotalItemsLength: response.data.data.pagination.total,
            };
        } catch (error) {
            console.error('Error fetching data:', error);
            return {
                serverCurrentPageItems: [],
                serverTotalItemsLength: 0,
            };
        }

        try {
            let config = {
                params: {
                    page: serverOptions.page,
                    limit: serverOptions.rowsPerPage,
                    order_by: serverOptions.sortBy,
                    order_direction: serverOptions.sortType,
                    filters: serverOptions.filters,
                },
            }

            config.params.start_date = serverOptions.start_date;
            config.params.end_date = serverOptions.end_date;

            const response = await epos2Axios.get('/api/orders/wait', config);

            return {
                serverCurrentPageItems: response.data.data.orders_wait,
                serverTotalItemsLength: response.data.data.pagination.found_rows,
            };
        } catch (error) {
            console.error('Error fetching data:', error);
            return {
                serverCurrentPageItems: [],
                serverTotalItemsLength: 0,
            };
        }
    }
    async updateOrder(orderid, field, value, pin="", override = false) {
        // return goAxios.patch('/api/orders/' + orderid+ '/?field=' + field, { value });
        let payload = {
            "field": field,
            "value": value,
            "pin": pin,
            "override": override,
        }

        return goAxios.patch(
          '/api/orders/' + orderid ,
            payload,
        );

    }

    async searchOrdersWait(serverOptions) {
        try {
            let config = {
                params: {
                    page: serverOptions.page,
                    limit: serverOptions.rowsPerPage,
                    order_by: serverOptions.sortBy,
                    order_direction: serverOptions.sortType,
                    filters: serverOptions.filters,
                },
            }

            config.params.start_date = serverOptions.start_date;
            config.params.end_date = serverOptions.end_date;

            const response = await epos2Axios.get('/api/orders/wait', config);

            return {
                serverCurrentPageItems: response.data.data.orders_wait,
                serverTotalItemsLength: response.data.data.pagination.found_rows,
            };
        } catch (error) {
            console.error('Error fetching data:', error);
            return {
                serverCurrentPageItems: [],
                serverTotalItemsLength: 0,
            };
        }
    }

    async downloadOrdersWait(serverOptions) {
        try {
            let  params = {
                order_by: serverOptions.sortBy,
                order_direction: serverOptions.sortType,
                filters: serverOptions.filters,
                export: 'csv',
            }
            if(serverOptions.start_date !== ""){
                params.start_date = serverOptions.start_date;
            }
            if(serverOptions.end_date !== ""){
                params.end_date = serverOptions.end_date;
            }
            const response = await epos2Axios.get('/api/orders/wait', {
                params,
                responseType: 'blob', // Set the response type to 'blob' for binary data
            });

            const blob = new Blob([response.data], { type: 'application/zip' });

            // We create a temporary link that contains the zip file
            // we then click it programmatically to download the file
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'orders_wait.zip';
            document.body.appendChild(link);
            link.click();

            // Remove the link from the document
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    }

    async searchOrdersPartials(serverOptions) {
        try {
            let config = {
                params: {
                    page: serverOptions.page,
                    limit: serverOptions.rowsPerPage,
                    order_by: serverOptions.sortBy,
                    order_direction: serverOptions.sortType,
                    filters: serverOptions.filters,
                },
            }

            config.params.start_date = serverOptions.start_date;
            config.params.end_date = serverOptions.end_date;
            config.params.payment = serverOptions.payment;

            const response = await epos2Axios.get('/api/orders/partials', config);

            return {
                serverCurrentPageItems: response.data.data.orders_partials,
                serverTotalItemsLength: response.data.data.pagination.found_rows,
            };
        } catch (error) {
            console.error('Error fetching data:', error);
            return {
                serverCurrentPageItems: [],
                serverTotalItemsLength: 0,
            };
        }
    }

    async downloadOrdersPartials(serverOptions) {
        try {
            let  params = {
                order_by: serverOptions.sortBy,
                order_direction: serverOptions.sortType,
                filters: serverOptions.filters,
                export: 'csv',
            }
            if(serverOptions.start_date !== ""){
                params.start_date = serverOptions.start_date;
            }
            if(serverOptions.end_date !== ""){
                params.end_date = serverOptions.end_date;
            }
            if(serverOptions.payment !== ""){
                params.payment = serverOptions.payment;
            }
            const response = await epos2Axios.get('/api/orders/partials', {
                params,
                responseType: 'blob', // Set the response type to 'blob' for binary data
            });

            const blob = new Blob([response.data], { type: 'application/zip' });

            // We create a temporary link that contains the zip file
            // we then click it programmatically to download the file
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'orders_partials.zip';
            document.body.appendChild(link);
            link.click();

            // Remove the link from the document
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    }

    async searchOrdersCredit(serverOptions) {
        try {
            const params = {
                search: serverOptions.search || '',
                page: serverOptions.page,
                limit: serverOptions.rowsPerPage,
                sort_by: serverOptions.sortBy,
                sort_direction: serverOptions.sortType,
                has_credit: serverOptions.has_credit,
                status_filter: serverOptions.status_filter,
                start_date: serverOptions.start_date,
                end_date: serverOptions.end_date,
                rfid_account: serverOptions.rfid_account,
                filters: serverOptions.filters
            };
            console.log(params);
            const response = await goAxios.get('/api/orders', { params });
            return {
                serverCurrentPageItems: response.data.data.orders || [],
                serverTotalItemsLength: response.data.data.pagination.total,
            };
        } catch (error) {
            console.error('Error fetching data:', error);
            return {
                serverCurrentPageItems: [],
                serverTotalItemsLength: 0,
            };
        }
    }
     async downloadOrdersCredit(serverOptions) {
        try {
             const params = {
                search: serverOptions.search || '',
                page: serverOptions.page,
                limit: serverOptions.rowsPerPage,
                sort_by: serverOptions.sortBy,
                sort_direction: serverOptions.sortType,
                has_credit: serverOptions.has_credit,
                status_filter: serverOptions.status_filter,
                start_date: serverOptions.start_date,
                end_date: serverOptions.end_date,
                rfid_account: serverOptions.rfid_account,
                filters: serverOptions.filters,
                type: 'csv'
            };
            console.log(params);
            const response = await goAxios.get('/api/orders', { params });
            const anchor = document.createElement('a');
            anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(response.data);
            anchor.target = '_blank';
            anchor.download = 'OrdersCreditApplied.csv';
            anchor.click();
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    }


    patchOrderUser(orderid, userid) {
        // $group->patch('/order/{orderid:[1-9][0-9]*}/user/{userid:[1-9][0-9]*}'
        return epos2Axios.patch(
            `/api/order/${orderid}/user/${userid}`,
            [],
            {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }
        );
    }
    patchOrderPriority(orderid, priority) {
        // $group->patch('/order/{orderid:[1-9][0-9]*}/priority/{priority:[A-Z]*}'
        return epos2Axios.patch(
            `/api/order/${orderid}/priority/${priority}`,
            [],
            {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }
        );
    }
    getOrderItems(id) {
        return epos2Axios.get('/api/order/' + id+'/undelivered-items');
    }

    async loadOrderItems(order_id) {
        try {
            const response = await goAxios.get('/api/orders/'+order_id+'/items');
            return {
                serverCurrentPageItems: response.data.data.order_items,
                serverTotalItemsLength: response.data.data.pagination.total,
            };
        } catch (error) {
            console.error('Error fetching data:', error);
            return {
                serverCurrentPageItems: [],
                serverTotalItemsLength: 0,
            };
        }
    }

    printWhiteTicket(id, user_session) {
       // return epos2Axios.get('/api/orders/' + id + '/servicetickets/print?user_session=' + user_session);
       return eposAxios.get('/index.php?page=ajax&function=printToEpson&orderid=' + id + '&tagcount=0&type=tickets');
    }

    addOrderItems(orderID, garmentID, garmentTypeID, action) {
        return goAxios.post('/api/orders/' + orderID + '/items',{
           garment_id:garmentID,
           garment_type_id: garmentTypeID,
           action: action
        });
    }

    setOrderItemStatus(orderID, orderitemid, status_id) {
        //POST /orders/{{orderid}}/items/{{orderitemid}}/status
        return goAxios.post('/api/orders/' + orderID + '/items/' + orderitemid + '/status',{
           status_id: status_id
        });
    }

    // /api/orders/{orderID:[0-9]+}/servicetickets/print
    printServiceTickets(orderID, params={}) {    
        // Build query params for printer_id, bedding, tickets
        const query = {};
        if (params.bedding !== undefined) query.bedding = params.bedding;
        if (params.is_processing !== undefined) query.is_processing = params.is_processing;
        if (params.tickets) query.tickets = Array.isArray(params.tickets) ? params.tickets.join(',') : params.tickets;
        //default towel_folding=true else params.towel_folding
        query.towel_folding = true
        if (params.towel_folding !== undefined) query.towel_folding = params.towel_folding;
        return goAxios.get('/api/orders/' + orderID + '/servicetickets/print', {
            params: query
        });  
    }
    printServiceTicketsQpup(orderID, params={}) {    
        // Build query params for printer_id, bedding, tickets
        const query = {};
        if (params.tickets) query.tickets = Array.isArray(params.tickets) ? params.tickets.join(',') : params.tickets;
        //return goAxios.get('/api/orders/' + orderID + '/servicetickets/print-qpup', {
        return goAxios.get('/api/orders/' + orderID + '/servicetickets/print', {
            params: query
        });  
    }
    getOrderItemDetails(orderItemID, type = 'details', qcHistory = false, qcNotes = false, logscan = false) {
        const params = new URLSearchParams();
        if (type === 'pieceup') params.append('pieceup', '1');
        if (type === 'qpup') params.append('qpup', '1');
        if (qcHistory) params.append('qchistory', '1');
        if (qcNotes) params.append('qcnotes', '1');
        if (logscan) params.append('logscan', '1');

        const queryString = params.toString();
        return goAxios.get('/api/orders/order-items/' + orderItemID + (queryString ? '?' + queryString : ''));
    }

    getGarmentDetails(garmentID, type = 'details', qcHistory = false, qcNotes = false, logscan = false) {
        const params = new URLSearchParams();
        if (type === 'pieceup') params.append('pieceup', '1');
         if (type === 'qpup') params.append('qpup', '1');
        if (qcHistory) params.append('qchistory', '1');
        if (qcNotes) params.append('qcnotes', '1');
        if (logscan) params.append('logscan', '1');

        const queryString = params.toString();
        return goAxios.get('/api/garments/' + garmentID + (queryString ? '?' + queryString : ''));
    }
    getGarmentDetailsByTag(garmentID, type = 'details', qcHistory = false, qcNotes = false, logscan = false) {
        const params = new URLSearchParams();
        if (type === 'pieceup') params.append('pieceup', '1');
         if (type === 'qpup') params.append('qpup', '1');
        if (qcHistory) params.append('qchistory', '1');
        if (qcNotes) params.append('qcnotes', '1');
        if (logscan) params.append('logscan', '1');

        const queryString = params.toString();
        return goAxios.get('/api/garments/tag/' + garmentID + (queryString ? '?' + queryString : ''));
    }
    getGarmentRFIDDetails(garmentRFID, type = 'details', qcHistory = false, qcNotes = false, logscan = false) {
        const params = new URLSearchParams();
        if (type === 'pieceup') params.append('pieceup', '1');
         if (type === 'qpup') params.append('qpup', '1');
        if (qcHistory) params.append('qchistory', '1');
        if (qcNotes) params.append('qcnotes', '1');
        if (logscan) params.append('logscan', '1');

        const queryString = params.toString();
        return goAxios.get('/api/rfid-garments/' + garmentRFID + (queryString ? '?' + queryString : ''));   
    }
    getTagRFIDDetails(garmentRFID, type= 'details', qcHistory = false, qcNotes = false, logscan = false) {
        const params = new URLSearchParams();
        if (type === 'pieceup') params.append('pieceup', '1');
         if (type === 'qpup') params.append('qpup', '1');
        if (qcHistory) params.append('qchistory', '1');
        if (qcNotes) params.append('qcnotes', '1');
        if (logscan) params.append('logscan', '1');

        const queryString = params.toString();
        return goAxios.get('/api/rfid-tag/' + garmentRFID + (queryString ? '?' + queryString : '')); 
         
    }
    
    failQCGarment(orderItemID, type = 'repair', pieceup = true, qpup = false, logscan = false) {
        //can be repair or cleaning or damage or stain or pressing
        const params = new URLSearchParams();
        if (pieceup) params.append('pieceup', '1');
        if (qpup) params.append('qpup', '1');
        if (logscan) params.append('logscan', '1');

        const queryString = params.toString();
        return goAxios.post('/api/orders/order-items/' + orderItemID + '/qc-fail/' + type + (queryString ? '?' + queryString : ''));
    }

    returnOnlyQCGarment(orderItemID, qpup = true, logscan = false) {
        const params = new URLSearchParams();
        if (qpup) params.append('qpup', '1');
        if (logscan) params.append('logscan', '1');
        return goAxios.post('/api/orders/order-items/' + orderItemID + '/qc-return' + (params.toString() ? '?' + params.toString() : ''));
    }

    
}

export default new OrderService();
